import axiosInstance from "./axiosInstance";

const packedProductsService = {
  create: async (payload) => {
    try {
      const response = await axiosInstance.post('/warehousePackedProdcuts/create', payload);
      return response.data;
    } catch (error) {
      // Safe error handling
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error while creating scanned item.";
      throw new Error(message);
    }
  },

  fetchAll: async () => {
    try {
      const response = await axiosInstance.get('/warehousePackedProdcuts/all');
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error fetching items.";
      throw new Error(message);
    }
  },

  fetchByData: async (id) => {
    try {
      const response = await axiosInstance.get(`/warehousePackedProdcuts/bydata/${id}`);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error fetching item0.";
      throw new Error(message);
    }
  },


  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/warehousePackedProdcuts/delete/${id}`);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error deleting item.";
      throw new Error(message);
    }
  },

  update: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/warehousePackedProdcuts/update/${id}`, payload);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Unknown error updating item.";
      throw new Error(message);
    }
  },
};

export default packedProductsService;

// import axiosInstance from "./axiosInstance";

// const packedProductsService = {
//   create: async (payload) => {
//     const response = await axiosInstance.post(
//       "/warehousePackedProdcuts/create",
//       payload
//     );
//     return response.data;
//   },

//   fetchAll: async () => {
//     const response = await axiosInstance.get("/warehousePackedProdcuts/all");
//     return response.data;
//   },

//   fetchByData: async (id) => {
//     const response = await axiosInstance.get(
//       `/warehousePackedProdcuts/bydata/${id}`
//     );
//     return response.data;
//   },

//   delete: async (id) => {
//     const response = await axiosInstance.get(
//       `/warehousePackedProdcuts/delete/${id}`
//     ); // backend route is GET delete/:id (not DELETE)
//     return response.data;
//   },

//   update: async (id, payload) => {
//     const response = await axiosInstance.put(
//       `/warehousePackedProdcuts/update/${id}`,
//       payload
//     );
//     return response.data;
//   },
// };

// export default packedProductsService;
